module.exports = __webpack_public_path__ + "0d2d3e2545abd9adf8b845a477da35bd.svg";